import React from "react";
import "./style.css";
import locationicon from "../../../src/assests/new/location-off.png";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet";

const FailedGeocheck = () => {
  const state = useSelector((state) => state);
  const { isVpn, isUserInAllowedRegion } = state?.auth;

  return (
    <div>
      <Helmet>
        <title>Location Unavailable | BettDraft Fantasy Sports</title>
        <meta name="description" content="BettDraft is not currently available in your location." />
      </Helmet>
      <div className="verification-box">
        <div className="inner-geodiv">
          <img className="locationicon" src={locationicon} alt="Location not available" />
          <span className="main-para">
          <span className="big-heading">
              {isVpn
                ? "VPN WARNING"
                : isUserInAllowedRegion
                ? "LOCATION WARNING"
                : ""}
            </span>
            <br />
            <span className="small-heading">
            {isVpn
                ? "To proceed, disable the proxy service on your device. Once you have resolved this error, please try login again."
                : isUserInAllowedRegion
                ? "It appears that you are currently located outside of our permitted gaming area. Unfortunately, this means you are unable to access our games at this time."
                : ""}
            </span>
          </span>
        </div>
      </div>
    </div>
  );
};

export default FailedGeocheck;
